import styles from './ChartsHeading.module.scss'

type Props = {
  description?: string
  heading: string
}

export const ChartsHeading = ({ description, heading }: Props) => (
  <div className={styles.container}>
    <h2>{heading}</h2>
    <p>{description}</p>
  </div>
)
